export const flowTypes = {
  buyNow: 'buyNow',
  basic2pro: 'basic2pro',
  edit: 'edit',
  add2cart: 'add2cart',
  pro2biz: 'pro2biz',
  downgrade: 'downgrade',
  upgrade: 'upgrade',
  trial2paid: 'trial2paid',
  // FREE TRIAL
  add2trial: 'add_trial'
};

export function installNewBillingConfig(pageInfo) {
  const newBillingConfig = window.newBillingConfig || {}
  const params = pageInfo.params || {}

  params.type = params.type || newBillingConfig.pageConfig?.type || flowTypes.buyNow

  pageInfo.params = params
  return pageInfo
}
